import { createThemeManager } from '@ui/lib/ui'
import { eventThemes, defaultTheme } from '@/config/events'

export const { getCurrentTheme, getThemeByKey } = createThemeManager({
  eventThemes,
  defaultTheme
})
